import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when an office clicks the Action Needed button on the dashboard
 * Event: dental_portal:dashboard:action_needed_clicked
 */
export function fireDashboardActionNeededClicked(): void {
  PosthogService.getInstance().track('dental_portal:dashboard:action_needed_clicked');
}
